import React from "react";
import css from "./style.scss";
import classNames from "classnames";

const ProgressBar = ({
  label = "Campaign Progress",
  value = 0,
  inactive = false,
  showHeader = true,
  isSmallSize = false
}) => {
  const progress = Math.min(100, Math.max(0, value));

  return (
    <div className={css.progressContainer}>
      {showHeader && (
        <div className={css.progressHeader}>
          <span className={css.progressLabel}>{label}</span>
          <span className={css.progressPercent}>{progress}%</span>
        </div>
      )}
      <div className={classNames(css.progressTrack, { [css.smallSize]: isSmallSize })}>
        <div
          className={
            inactive
              ? css.progressFillInactive
              : css.progressFill
          }
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
};

export default ProgressBar;